// ── Images ─────────────────────────────────────────────────────────────────
import IMG_LOGO from "../assets/logo.png";


// ── Colors ─────────────────────────────────────────────────────────────────
const C = {
  cream:"#fdf8fc", paper:"#f9eef6", pink:"#d94fa0", pinkDk:"#b03680",
  pinkLt:"#f0a0cc", purple:"#4b3f8e", purpleDk:"#362d6e", purpleLt:"#9b91d0",
  rose:"#fce4f2", brown:"#2d1a2e", brownMd:"#6b3a5a", brownLt:"#b08898",
  blush:"#f5dced", white:"#ffffff", gold:"#d4a843",
};

// ── Wompi El Salvador config ─────────────────────────────────────────────────
// The App ID and API Secret must stay on the server (api/wompi.php).
// This URL points to your PHP proxy which creates the payment link securely.
const WOMPI_API_PROXY  = "./api/wompi.php"; // ← PHP proxy (included in download)
const IG_HANDLE        = "handcraftsbyabu";

// ── Admin config ────────────────────────────────────────────────────────────
const MAX_ORDERS         = 20;
const MAX_PER_PRODUCT    = 8;

// ── API URL — update this to your Hostinger domain ───────────────────────────
const API_URL = "./api/products.php"; // change to full URL if needed e.g. "https://yourdomain.com/api/products.php"
const SEED_PRODUCTS_URL = "./seed-products.json";

// ── Translations ─────────────────────────────────────────────────────────────
const T = {
  es: {
    // Nav
    nav_inicio:"Inicio", nav_tienda:"Tienda", nav_entrega:"Entrega", nav_nosotros:"Nosotros",
    nav_encargo:"✨ Encargo", nav_carrito:"🛒 Carrito",
    nav_inicio_m:"🏠 Inicio", nav_tienda_m:"🧶 Tienda", nav_nosotros_m:"🌸 Nosotros",
    nav_encargo_m:"✨ Hacer Encargo",
    // Hero
    hero_tag:"🇸🇻 Hecho con manos salvadoreñas",
    hero_sub:"Tejidos hechos con amor por manos salvadoreñas",
    hero_desc:"Juguetes · Adornos · Vírgenes · Ángeles · Nacimientos\nEntregas a todo El Salvador 📦",
    hero_btn1:"Ver Colección", hero_btn2:"✨ Hacer Encargo",
    hero_badges:["🤲 Tejido a mano","📦 Envío SV","💳 Pago seguro con Wompi","⭐ 4,734 seguidores"],
    // Sections
    sec_favoritos:"Nuestros Favoritos 🌸",
    sec_ver_todo:"Ver Toda la Colección →",
    sec_como:"¿Cómo funciona? 🧶",
    sec_pagos:"Métodos de pago:",
    sec_testimonios:"Lo que dicen nuestros clientes 💕",
    sec_encargo_cta:"✨ Hacer mi Encargo Especial",
    // Steps
    step1_t:"Elige tu tejido", step1_d:"Explora la tienda, escoge tu favorito o describe tu idea personalizada.",
    step2_t:"Paga seguro",     step2_d:"Pago 100% seguro con Wompi El Salvador. Acepta tarjeta, Puntos Agrícola y Bitcoin.",
    step3_t:"Abu teje con amor",step3_d:"Cada pieza se teje a mano con cuidado y dedicación especial para ti.",
    step4_t:"Lo recibes",    step4_d:"Envios a todo El Salvador y Estados Unidos. Pickup disponible.",
    // Tienda
    tienda_title:"Tienda 🧶",
    tienda_sub:"Cada pieza tejida a mano con amor — {n} creaciones disponibles",
    tienda_buscar:"Buscar productos...",
    tienda_todos:"Todos",
    tienda_encargo_cta:"¿No encuentras lo que buscas?",
    tienda_encargo_sub:"Abu puede tejer tu idea personalizada 🌸",
    tienda_encargo_btn:"✨ Hacer Encargo",
    tienda_sin_stock:"Agotado",
    tienda_ver_mas:"Ver más",
    tienda_comprar:"Comprar 💳",
    tienda_ul_stock:"⚠️ ¡Última unidad!",
    // Nosotros
    nos_title:"Nuestra Historia 🌸",
    nos_sub:"Handcrafts By Abu nació del amor por el tejido y el deseo de compartir ese amor con el mundo.",
    nos_hola:"Hola, soy Abu 👋",
    nos_bio1:"Soy una artesana salvadoreña apasionada por el tejido amigurumi. Lo que empezó como un hobby se convirtió en mi forma de llevar alegría a cada hogar.",
    nos_bio2:"Cada pieza que sale de mis manos lleva un pedacito de mi corazón. 🌸",
    nos_ig:"📸 Sígueme en Instagram",
    nos_valores:"Nuestros Valores 💛",
    nos_proceso:"Mi proceso 🧶",
    nos_cta_title:"¿Lista para encargar? 🌸",
    nos_cta_sub:"Escríbeme por Instagram o haz tu pedido aquí mismo.",
    nos_cta_btn1:"Ver Tienda", nos_cta_btn2:"✨ Encargo Especial",
    nos_faq_title:"Preguntas frecuentes 💬",
    faqs:[
      ["¿Cuánto tiempo tarda un pedido?","Depende del producto: piezas simples 3–5 días, complejas hasta 10–14 días. Se te informará el tiempo exacto al confirmar."],
      ["Hacen envios fuera de El Salvador?","Si. Enviamos a todo El Salvador y a Estados Unidos. El costo para Estados Unidos se coordina directamente con Abu."],
      ["¿Cómo puedo pagar?","Aceptamos pagos seguros a través de Wompi El Salvador: tarjeta de crédito/débito, Puntos Agrícola y Bitcoin (Chivo Wallet)."],
      ["¿Pueden personalizar los colores?","¡Absolutamente! Al hacer tu encargo especial indícanos los colores y detalles que deseas."],
      ["¿Qué pasa si mi pedido llega dañado?","Nos aseguraremos de resolver el problema. Escríbenos por Instagram con fotos y buscamos la mejor solución."],
    ],
    valores:[
      {icon:"🤲",t:"Hecho a Mano",d:"Cada pieza es tejida completamente a mano, sin máquinas, con dedicación y paciencia."},
      {icon:"💛",t:"Con Amor",d:"Cada punto lleva una intención especial. Abu teje pensando en la persona que lo recibirá."},
      {icon:"🇸🇻",t:"Orgullo Salvadoreño",d:"Hecho en El Salvador con materiales de calidad y técnicas artesanales tradicionales."},
      {icon:"🌱",t:"Materiales Seguros",d:"Hilos suaves y seguros para bebés y niños, sin químicos dañinos."},
    ],
    proceso:[
      {n:1,icon:"💬",t:"Consulta",d:"Cuéntanos qué quieres o elige de nuestra colección."},
      {n:2,icon:"🎨",t:"Diseño",d:"Abu selecciona colores y materiales perfectos para tu pedido."},
      {n:3,icon:"🧶",t:"Tejido",d:"Cada pieza se teje a mano con técnica amigurumi japonesa."},
      {n:4,icon:"💳",t:"Pago seguro",d:"Paga con Wompi: tarjeta, PSE y más. Luego coordinamos la entrega."},
    ],
    testimonios:[
      {name:"Karla M.",stars:5,text:"¡Abu me hizo un osito para el baby shower de mi hermana y quedó hermoso! Super detallado y llegó antes de tiempo 🥺🧶"},
      {name:"Roberto S.",stars:5,text:"La Virgen que me tejió es una obra de arte. Ya la tengo en el altar de mi mamá y todos preguntan dónde la conseguí."},
      {name:"Diana P.",stars:5,text:"Pedí una muñeca personalizada y Abu se aseguró que los colores quedaran perfectos. ¡Volveré a pedir! 💕"},
      {name:"Margarita V.",stars:5,text:"El set bebé para mi nieta llegó súper bien empacado. Se nota el amor en cada detalle. 100% recomendado 🌸"},
    ],
    // Footer
    footer_sub:"Tejidos artesanales hechos con amor en El Salvador 🇸🇻",
    footer_copy:"© 2025 Handcrafts By Abu · El Salvador",
    // Cart
    cart_title:"🛒 Tu Carrito",
    cart_empty:"Tu carrito está vacío",
    cart_ver_tienda:"Ver Tienda",
    cart_subtotal:"Subtotal",
    cart_envio:"+ Envio en El Salvador desde $3. Estados Unidos se coordina con Abu.",
    cart_pagar:"💳 Proceder al Pago →",
    cart_remove_all:"Quitar todo",
    cart_empty_icon:"Bolsa vacia",
    // Detail modal
    detail_al_carrito:"🛒 Al Carrito",
    detail_comprar:"💳 Comprar Ahora",
    // Custom order modal
    custom_title:"✨ Encargo a Medida",
    custom_sub:"Cuéntame qué quieres y Abu te dará ideas de diseño 🌸",
    custom_label:"¿Qué quieres que Abu teja?",
    custom_placeholder:"Ej: Una Virgen de Guadalupe con manto azul y dorado...",
    custom_btn_loading:"🔍 Buscando ideas...",
    custom_btn:"🔍 Buscar Ideas de Diseño",
    custom_gusto:"¿Te gustó?",
    custom_ig:"Abu coordinará los detalles por Instagram",
    custom_hacer:"Hacer Encargo 💛",
    custom_sent_title:"¡Borrador listo!",
    custom_sent_sub:"Copiamos tu mensaje y abrimos Instagram para enviarlo a",
    custom_sent_btn:"Cerrar 💛",
    custom_copy_error:"No se pudo copiar automáticamente. Copia el texto manualmente.",
    custom_draft_label:"Mensaje para Instagram",
    custom_open_ig:"Abrir Instagram",
    custom_copy_again:"Copiar otra vez",
    // PIN
    pin_title:"Acceso Privado",
    pin_sub:"Panel de pedidos de Abu 🧶",
    pin_placeholder:"PIN",
    pin_btn:"Entrar →",
    pin_hint:"Solo Abu sabe el PIN 🌸",
    pin_error:"PIN incorrecto.",
  },
  en: {
    // Nav
    nav_inicio:"Home", nav_tienda:"Shop", nav_entrega:"Delivery", nav_nosotros:"About",
    nav_encargo:"✨ Custom Order", nav_carrito:"🛒 Cart",
    nav_inicio_m:"🏠 Home", nav_tienda_m:"🧶 Shop", nav_nosotros_m:"🌸 About",
    nav_encargo_m:"✨ Place Custom Order",
    // Hero
    hero_tag:"🇸🇻 Handmade in El Salvador",
    hero_sub:"Crochet pieces made with love by Salvadoran hands",
    hero_desc:"Toys · Ornaments · Virgins · Angels · Nativity Sets\nShipping across El Salvador 📦",
    hero_btn1:"View Collection", hero_btn2:"✨ Place Custom Order",
    hero_badges:["🤲 Handmade","📦 SV Shipping","💳 Secure payment via Wompi","⭐ 4,734 followers"],
    // Sections
    sec_favoritos:"Our Favorites 🌸",
    sec_ver_todo:"View Full Collection →",
    sec_como:"How does it work? 🧶",
    sec_pagos:"Payment methods:",
    sec_testimonios:"What our customers say 💕",
    sec_encargo_cta:"✨ Place My Custom Order",
    // Steps
    step1_t:"Choose your piece",  step1_d:"Browse the shop, pick your favorite, or describe your custom idea.",
    step2_t:"Pay securely",       step2_d:"100% secure payment with Wompi El Salvador. Accepts cards, Agrícola Points and Bitcoin.",
    step3_t:"Abu crochets with love", step3_d:"Each piece is handcrafted with care and special dedication just for you.",
    step4_t:"Receive it!",        step4_d:"Shipping across El Salvador and the United States. Pickup available.",
    // Tienda
    tienda_title:"Shop 🧶",
    tienda_sub:"Each piece handcrafted with love — {n} creations available",
    tienda_buscar:"Search products...",
    tienda_todos:"All",
    tienda_encargo_cta:"Can't find what you're looking for?",
    tienda_encargo_sub:"Abu can crochet your custom idea 🌸",
    tienda_encargo_btn:"✨ Place Custom Order",
    tienda_sin_stock:"Sold Out",
    tienda_ver_mas:"Details",
    tienda_comprar:"Buy 💳",
    tienda_ul_stock:"⚠️ Last unit!",
    // Nosotros
    nos_title:"Our Story 🌸",
    nos_sub:"Handcrafts By Abu was born from a love of crochet and a desire to share that love with the world.",
    nos_hola:"Hi, I'm Abu 👋",
    nos_bio1:"I'm a Salvadoran artisan passionate about amigurumi crochet. What started as a hobby became my way of bringing joy to every home.",
    nos_bio2:"Every piece that leaves my hands carries a little piece of my heart. 🌸",
    nos_ig:"📸 Follow me on Instagram",
    nos_valores:"Our Values 💛",
    nos_proceso:"My Process 🧶",
    nos_cta_title:"Ready to order? 🌸",
    nos_cta_sub:"Message me on Instagram or place your order right here.",
    nos_cta_btn1:"View Shop", nos_cta_btn2:"✨ Custom Order",
    nos_faq_title:"Frequently Asked Questions 💬",
    faqs:[
      ["How long does an order take?","It depends on the piece: simple items 3–5 days, complex up to 10–14 days. You'll be told the exact time when confirming."],
      ["Do you ship outside El Salvador?","Yes. We ship across El Salvador and to the United States. U.S. shipping is coordinated directly with Abu."],
      ["How can I pay?","We accept secure payments through Wompi El Salvador: credit/debit cards, Agrícola Points and Bitcoin (Chivo Wallet)."],
      ["Can you customize colors?","Absolutely! When placing your custom order, just let us know the colors and details you want."],
      ["What if my order arrives damaged?","We'll make sure to resolve the issue. Message us on Instagram with photos and we'll find the best solution."],
    ],
    valores:[
      {icon:"🤲",t:"Handmade",d:"Every piece is crocheted entirely by hand, no machines, with dedication and patience."},
      {icon:"💛",t:"Made with Love",d:"Every stitch carries a special intention. Abu crochets thinking of the person who will receive it."},
      {icon:"🇸🇻",t:"Salvadoran Pride",d:"Made in El Salvador with quality materials and traditional artisan techniques."},
      {icon:"🌱",t:"Safe Materials",d:"Soft yarns safe for babies and children, free from harmful chemicals."},
    ],
    proceso:[
      {n:1,icon:"💬",t:"Consultation",d:"Tell us what you want or choose from our collection."},
      {n:2,icon:"🎨",t:"Design",d:"Abu selects the perfect colors and materials for your order."},
      {n:3,icon:"🧶",t:"Crocheting",d:"Each piece is handcrafted using Japanese amigurumi technique."},
      {n:4,icon:"💳",t:"Secure Payment",d:"Pay with Wompi: card, PSE and more. Then we coordinate delivery."},
    ],
    testimonios:[
      {name:"Karla M.",stars:5,text:"Abu made me a little bear for my sister's baby shower and it was gorgeous! Super detailed and arrived ahead of time 🥺🧶"},
      {name:"Roberto S.",stars:5,text:"The Virgin she crocheted is a work of art. It's on my mom's altar and everyone asks where I got it."},
      {name:"Diana P.",stars:5,text:"I ordered a custom doll and Abu made sure the colors were perfect. I'll be ordering again! 💕"},
      {name:"Margarita V.",stars:5,text:"The baby set for my granddaughter arrived beautifully packed. You can feel the love in every detail. 100% recommended 🌸"},
    ],
    // Footer
    footer_sub:"Artisan crochet made with love in El Salvador 🇸🇻",
    footer_copy:"© 2025 Handcrafts By Abu · El Salvador",
    // Cart
    cart_title:"🛒 Your Cart",
    cart_empty:"Your cart is empty",
    cart_ver_tienda:"View Shop",
    cart_subtotal:"Subtotal",
    cart_envio:"+ El Salvador shipping from $3. U.S. shipping is coordinated with Abu.",
    cart_pagar:"💳 Proceed to Checkout →",
    cart_remove_all:"Remove item",
    cart_empty_icon:"Empty bag",
    // Detail modal
    detail_al_carrito:"🛒 Add to Cart",
    detail_comprar:"💳 Buy Now",
    // Custom order modal
    custom_title:"✨ Custom Order",
    custom_sub:"Tell me what you want and Abu will give you design ideas 🌸",
    custom_label:"What would you like Abu to crochet?",
    custom_placeholder:"E.g.: A Virgin of Guadalupe with a blue and gold mantle...",
    custom_btn_loading:"🔍 Looking for ideas...",
    custom_btn:"🔍 Search Design Ideas",
    custom_gusto:"Did you like it?",
    custom_ig:"Abu will coordinate details via Instagram",
    custom_hacer:"Place Order 💛",
    custom_sent_title:"Draft ready!",
    custom_sent_sub:"We copied your message and opened Instagram so you can send it to",
    custom_sent_btn:"Close 💛",
    custom_copy_error:"We could not copy it automatically. Copy the text manually.",
    custom_draft_label:"Instagram message",
    custom_open_ig:"Open Instagram",
    custom_copy_again:"Copy again",
    // PIN
    pin_title:"Private Access",
    pin_sub:"Abu's orders panel 🧶",
    pin_placeholder:"PIN",
    pin_btn:"Enter →",
    pin_hint:"Only Abu knows the PIN 🌸",
    pin_error:"Incorrect PIN.",
  },
};


// ── Shipping zones ──────────────────────────────────────────────────────────
const SHIPPING_ZONES = [
  { id:"sv_metro",  label:"San Salvador (Metro)",        price:3,  days:"1-2 dias" },
  { id:"sv_local",  label:"El Salvador (Departamentos)", price:5,  days:"2-4 dias" },
  { id:"us",        label:"Estados Unidos",              price:0,  days:"7-12 dias", displayPrice:"Coordinar con Abu" },
  { id:"pickup",    label:"Recoger en persona",          price:0,  days:"Coordinar" },
];

const ORDER_STATUS = {
  payment_pending: { label:"Pago pendiente", color:"#ec4899", bg:"#fdf2f8", icon:"💳" },
  pending:   { label:"Pendiente", color:"#f59e0b", bg:"#fffbeb", icon:"⏳" },
  weaving:   { label:"Tejiendo",  color:"#8b5cf6", bg:"#f5f3ff", icon:"🧶" },
  ready:     { label:"Listo",     color:"#10b981", bg:"#ecfdf5", icon:"✅" },
  shipped:   { label:"Enviado",   color:"#3b82f6", bg:"#eff6ff", icon:"📦" },
  delivered: { label:"Entregado", color:"#6b7280", bg:"#f9fafb", icon:"🎉" },
  cancelled: { label:"Cancelado", color:"#ef4444", bg:"#fef2f2", icon:"❌" },
};

const fmtMoney   = n => `$${Number(n).toFixed(2)}`;
const fmtDate    = d => new Date(d).toLocaleDateString("es-SV",{day:"2-digit",month:"short",year:"numeric"});
const todayStr   = () => new Date().toISOString().split("T")[0];
const genId      = () => "ORD-" + Date.now().toString(36).toUpperCase().slice(-6);

function calcCapacity(orders) {
  const active = orders.filter(o => !["payment_pending","delivered","cancelled"].includes(o.status));
  return { active: active.length, pct: Math.round(active.length / MAX_ORDERS * 100), max: MAX_ORDERS };
}
function calcProductLoad(orders) {
  const active = orders.filter(o => !["payment_pending","delivered","cancelled"].includes(o.status));
  const counts = {};
  active.forEach(o => o.items.forEach(i => { counts[i.productId] = (counts[i.productId]||0) + i.qty; }));
  return counts;
}
function calcTotals(items, zoneId) {
  const subtotal = items.reduce((s,i) => s + i.price * i.qty, 0);
  const zone     = SHIPPING_ZONES.find(z => z.id === zoneId) || SHIPPING_ZONES[0];
  return { subtotal, shipping: zone.price, total: subtotal + zone.price, zone };
}

const SEED = [
  { id:"ORD-DEMO01", createdAt:"2025-02-10", status:"weaving",
    customer:{ name:"María García", phone:"7890-1234", instagram:"@maria_g" },
    address:{ street:"Col. Escalón #45", city:"San Salvador", dept:"San Salvador", country:"El Salvador", notes:"Timbre azul" },
    shippingZone:"sv_metro",
    items:[{ productId:3, name:"Muñeca Rizada", qty:1, price:55, emoji:"👧" }],
    notes:"Cabello café, vestido azul marino", isPaid:true, payMethod:"Wompi" },
  { id:"ORD-DEMO02", createdAt:"2025-02-14", status:"pending",
    customer:{ name:"Carlos Mejía", phone:"6543-9876", instagram:"@carlos_m" },
    address:{ street:"Final Calle Real #12", city:"Santa Ana", dept:"Santa Ana", country:"El Salvador", notes:"" },
    shippingZone:"sv_local",
    items:[
      { productId:5, name:"Osito de Amor", qty:2, price:30, emoji:"🐻" },
      { productId:4, name:"Set Bebé",      qty:1, price:35, emoji:"🐼" },
    ],
    notes:"Baby shower 3 de marzo", isPaid:false, payMethod:"" },
];

// ── CSS ─────────────────────────────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Nunito:wght@400;500;600;700;800&display=swap');
*, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
html { scroll-behavior:smooth; }
.sans  { font-family:'Nunito',sans-serif; }
.serif { font-family:'Playfair Display',serif; }

.btn { font-family:'Nunito',sans-serif; font-weight:700; border:none; border-radius:50px; cursor:pointer; transition:all .18s ease; display:inline-flex; align-items:center; justify-content:center; gap:6px; line-height:1; text-decoration:none; white-space:nowrap; }
.btn:disabled { opacity:.45; cursor:not-allowed; pointer-events:none; }

.btn-solid  { background:#d94fa0; color:#fff; padding:11px 24px; font-size:14px; box-shadow:0 4px 0 #b03680; }
.btn-solid:hover  { background:#b03680; transform:translateY(-2px); box-shadow:0 6px 0 #8a2060; }
.btn-solid:active { transform:translateY(2px); box-shadow:0 2px 0 #b03680; }

.btn-purple { background:#4b3f8e; color:#fff; padding:11px 22px; font-size:14px; box-shadow:0 4px 0 #362d6e; }
.btn-purple:hover { background:#362d6e; transform:translateY(-2px); }

.btn-outline { background:transparent; color:#d94fa0; border:2.5px solid #d94fa0; padding:9px 22px; font-size:14px; }
.btn-outline:hover { background:#fce4f2; transform:translateY(-1px); }

.btn-ghost { background:transparent; color:#6b3a5a; border:none; padding:8px 14px; font-size:14px; border-radius:10px; }
.btn-ghost:hover { background:#f9eef6; }

.btn-white { background:#fff; color:#d94fa0; padding:13px 28px; font-size:15px; box-shadow:0 4px 0 rgba(0,0,0,0.12); }
.btn-white:hover { transform:translateY(-2px); box-shadow:0 6px 0 rgba(0,0,0,0.18); }

.btn-full { width:100%; }

.nav-link { font-family:'Nunito',sans-serif; font-weight:600; font-size:14px; color:#6b3a5a; cursor:pointer; padding:6px 0; background:none; border:none; border-bottom:2.5px solid transparent; transition:all .18s; }
.nav-link:hover { color:#d94fa0; border-bottom-color:#f0a0cc; }
.nav-link.active { color:#d94fa0; border-bottom-color:#d94fa0; font-weight:800; }

.product-card { background:#fff; border-radius:20px; overflow:hidden; box-shadow:0 3px 14px rgba(45,26,46,0.08); transition:transform .22s ease, box-shadow .22s ease; border:1.5px solid rgba(217,79,160,0.1); display:flex; flex-direction:column; }
.product-card:hover { transform:translateY(-5px); box-shadow:0 12px 32px rgba(45,26,46,0.14); }

.badge { font-family:'Nunito',sans-serif; font-size:10px; font-weight:800; letter-spacing:.7px; text-transform:uppercase; padding:4px 11px; border-radius:20px; background:#fce4f2; color:#b03680; }

.pill { font-family:'Nunito',sans-serif; font-weight:700; font-size:13px; padding:8px 18px; border-radius:50px; cursor:pointer; border:2px solid #f0a0cc; background:#fff; color:#6b3a5a; transition:all .15s; }
.pill:hover { border-color:#d94fa0; color:#d94fa0; }
.pill.active { background:#d94fa0; color:#fff; border-color:#d94fa0; box-shadow:0 3px 0 #b03680; }

.search-input { font-family:'Nunito',sans-serif; font-size:14px; padding:10px 18px 10px 40px; border-radius:50px; border:2px solid #f0a0cc; background:#fff; color:#2d1a2e; outline:none; transition:border-color .18s; width:220px; }
.search-input:focus { border-color:#d94fa0; }
.search-input::placeholder { color:#b08898; }

.overlay { position:fixed; inset:0; background:rgba(45,26,46,0.55); backdrop-filter:blur(5px); z-index:300; display:flex; align-items:center; justify-content:center; padding:16px; animation:fadeIn .2s ease; }
.modal { background:#fdf8fc; border-radius:28px; padding:36px 32px; max-width:560px; width:100%; max-height:90vh; overflow-y:auto; animation:slideUp .25s ease; box-shadow:0 24px 64px rgba(45,26,46,0.22); border:2px solid #f9eef6; }
.modal::-webkit-scrollbar { width:5px; }
.modal::-webkit-scrollbar-thumb { background:#f0a0cc; border-radius:10px; }

@keyframes fadeIn  { from{opacity:0} to{opacity:1} }
@keyframes slideUp { from{opacity:0;transform:translateY(26px)} to{opacity:1;transform:translateY(0)} }
@keyframes pop     { from{opacity:0;transform:scale(.5)} to{opacity:1;transform:scale(1)} }
@keyframes spin    { to{transform:rotate(360deg)} }

.spinner { width:30px; height:30px; border:3px solid #fce4f2; border-top-color:#d94fa0; border-radius:50%; animation:spin .7s linear infinite; margin:24px auto; }

textarea { width:100%; padding:15px; border-radius:15px; border:2.5px solid #f9eef6; font-family:'Nunito',sans-serif; font-size:14px; background:#fff; color:#2d1a2e; resize:vertical; min-height:108px; outline:none; transition:border-color .18s; line-height:1.65; }
textarea:focus { border-color:#d94fa0; }
textarea::placeholder { color:#b08898; }

.pattern-box { background:#fff; border-radius:16px; padding:20px 22px; margin-top:18px; border-left:5px solid #d94fa0; white-space:pre-wrap; font-family:'Nunito',sans-serif; font-size:13.5px; line-height:1.8; color:#2d1a2e; animation:slideUp .3s ease; }

.added-flash { position:absolute; top:-10px; right:-10px; background:#4b3f8e; color:#fff; font-family:'Nunito',sans-serif; font-size:11px; font-weight:800; padding:5px 12px; border-radius:20px; animation:pop .3s ease; box-shadow:0 2px 8px rgba(0,0,0,0.15); z-index:2; white-space:nowrap; }

.cart-item { display:flex; align-items:center; gap:14px; padding:14px 0; border-bottom:1.5px solid #f9eef6; }

.faq-item { border-bottom:1.5px solid #f9eef6; }
.faq-q { width:100%; text-align:left; background:none; border:none; font-family:'Nunito',sans-serif; font-weight:700; font-size:15px; color:#2d1a2e; cursor:pointer; padding:18px 0; display:flex; justify-content:space-between; align-items:center; gap:12px; transition:color .15s; }
.faq-q:hover { color:#d94fa0; }
.faq-a { font-family:'Nunito',sans-serif; font-size:14px; line-height:1.75; color:#6b3a5a; padding:0 0 18px; display:none; }
.faq-a.open { display:block; animation:slideUp .2s ease; }

.section-title { font-size:clamp(22px,3vw,34px); letter-spacing:-.5px; }
.divider { text-align:center; color:#f0a0cc; font-size:18px; letter-spacing:10px; opacity:.7; margin:8px 0 28px; }
.step-card { background:#fff; border-radius:20px; padding:28px 22px; border:1.5px solid #fce4f2; text-align:center; flex:1; min-width:150px; }
.step-num { width:40px; height:40px; background:#d94fa0; color:#fff; border-radius:50%; display:flex; align-items:center; justify-content:center; font-family:'Nunito',sans-serif; font-weight:800; font-size:16px; margin:0 auto 14px; box-shadow:0 3px 0 #b03680; }
.value-card { background:#fff; border-radius:20px; padding:28px 26px; border:1.5px solid #f9eef6; box-shadow:0 3px 14px rgba(45,26,46,0.06); }

/* ── HAMBURGER MENU ── */
.hamburger { display:none; flex-direction:column; gap:5px; cursor:pointer; padding:8px; background:none; border:none; }
.hamburger span { display:block; width:22px; height:2.5px; background:#6b3a5a; border-radius:4px; transition:all .25s; }
.hamburger.open span:nth-child(1) { transform:translateY(7.5px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity:0; transform:scaleX(0); }
.hamburger.open span:nth-child(3) { transform:translateY(-7.5px) rotate(-45deg); }

.mobile-menu {
  display:none; position:fixed; inset:0; top:68px; background:#fdf8fc;
  z-index:49; flex-direction:column; padding:24px 24px 40px;
  border-top:1.5px solid #f9eef6;
  box-shadow:0 8px 32px rgba(45,26,46,0.1);
  animation:slideDown .2s ease;
  overflow-y:auto;
}
.mobile-menu.open { display:flex; }
@keyframes slideDown { from{opacity:0;transform:translateY(-10px)} to{opacity:1;transform:translateY(0)} }

.mobile-nav-link {
  font-family:'Nunito',sans-serif; font-weight:700; font-size:20px;
  color:#2d1a2e; padding:16px 0; border-bottom:1.5px solid #f9eef6;
  background:none; border-left:none; border-right:none; border-top:none;
  text-align:left; cursor:pointer; transition:color .15s;
}
.mobile-nav-link:hover, .mobile-nav-link.active { color:#d94fa0; }

/* ── DESKTOP: hide mobile-only elements ── */
@media (min-width: 769px) {
  .mobile-actions { display:none !important; }
}

/* ── MOBILE BREAKPOINTS ── */
@media (max-width: 768px) {
  /* Nav */
  .desktop-nav { display:none !important; }
  .desktop-actions { display:none !important; }
  .hamburger { display:flex !important; }
  .nav-logo-wrap { flex:1; }

  /* Hero grid → stack */
  .hero-grid { grid-template-columns:1fr !important; gap:32px !important; text-align:center; }
  .hero-grid .hero-text { order:1; }
  .hero-grid .hero-imgs { order:2; }
  .hero-grid .hero-text > div:first-child { justify-content:center; }
  .hero-btns { justify-content:center !important; }
  .hero-badges { justify-content:center !important; }
  .hero-imgs { grid-template-columns:1fr 1fr !important; }
  .hero-imgs > div { transform:none !important; height:110px !important; }

  /* About grid → stack */
  .about-grid { grid-template-columns:1fr !important; text-align:center; gap:28px !important; padding:28px 22px !important; }
  .about-grid > div:first-child { margin:0 auto; }
  .about-grid a { margin:0 auto; }

  /* Toolbar wrap */
  .toolbar-wrap { flex-direction:column !important; align-items:stretch !important; }
  .toolbar-wrap select { margin-left:0 !important; }
  .search-input { width:100% !important; }
  .pills-wrap { flex-wrap:wrap !important; }

  /* Steps → 2 col */
  .steps-wrap { display:grid !important; grid-template-columns:1fr 1fr !important; }

  /* Payment logos strip → smaller */
  .pay-strip { gap:14px !important; padding:14px 18px !important; flex-wrap:wrap; }

  /* Modal padding */
  .modal { padding:28px 20px !important; border-radius:20px !important; }

  /* Cart item */
  .cart-item { gap:10px !important; }

  /* Nosotros hero */
  .nosotros-hero { padding:48px 20px 56px !important; }

  /* CTA sections */
  .cta-box { padding:40px 24px !important; }
  .cta-box h2 { font-size:clamp(20px,4vw,28px) !important; }
}

@media (max-width: 480px) {
  /* Tighter padding globally */
  section { padding-left:16px !important; padding-right:16px !important; }

  /* Nav height */
  .nav-inner { height:60px !important; }

  /* Hero */
  .hero-section { padding:48px 16px 60px !important; }
  h1 { font-size:clamp(28px,8vw,40px) !important; }

  /* Products single col on very small */
  .products-grid { grid-template-columns:1fr !important; }

  /* Steps single col */
  .steps-wrap { grid-template-columns:1fr !important; }

  /* Values 2 col */
  .values-grid { grid-template-columns:1fr 1fr !important; }

  /* Testimonials single col */
  .testi-grid { grid-template-columns:1fr !important; }

  /* Bottom CTA flex → stack */
  .bottom-cta { flex-direction:column !important; text-align:center !important; }

  /* Modal full screen on tiny phones */
  .modal { max-height:96vh !important; border-radius:16px !important; }

  /* Wompi button text */
  .pay-strip span { font-size:11px !important; }

  /* Card form half-width inputs → full on tiny screens */
  .card-half { width:100% !important; margin-right:0 !important; }
}
`

// ─────────────────────────────────────────────────────────────────────────────
//  SHARED UI COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

export {
  API_URL,
  C,
  CSS,
  IG_HANDLE,
  IMG_LOGO,
  MAX_PER_PRODUCT,
  ORDER_STATUS,
  SEED,
  SEED_PRODUCTS_URL,
  SHIPPING_ZONES,
  T,
  WOMPI_API_PROXY,
  calcCapacity,
  calcProductLoad,
  calcTotals,
  fmtDate,
  fmtMoney,
  genId,
  todayStr,
};
